import { Outlet, useMatches, useRouterState } from "@tanstack/react-router";
import { AppShell } from "@/app/layouts/AppShell";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";

export function RootLayout() {
  const isAuthRoute = useRouterState({
    select: (state) => state.location.pathname.startsWith("/auth"),
  });

  const matches = useMatches();
  const deepestTitle = [...matches]
    .reverse()
    .find((m) => m.staticData?.title)?.staticData?.title;

  useDocumentTitle(deepestTitle);

  if (isAuthRoute) {
    return <Outlet />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
